import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    DtgListType
} from "src/app/shared/vo";

@Component({
    templateUrl: "./dtg.manage.company.search.component.html"
})
export class DtgManageCompanySearchComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    DtgListType = DtgListType;

    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
    ) {
        
    }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {}

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }

    callbackSelectCompany(companyInfo:any){
        this.clickSelectCompany(companyInfo);
    }

    clickSelectCompany(companyInfo:any){
        this.activeModal.close({
            "result":"ok"
            ,"companyInfo":companyInfo
        });
    }
}
